import md5 from "md5";

function hash(data) {
  const hash = md5(data);
  // Return the first 8 characters of the hash as the unique key
  return hash.substring(0, 8);
}

export function uniqueKey(data) {
  if (typeof data === "string") {
    return hash(data);
  }
  if (typeof data == "object") {
    if (data.key) return String(data.key);
    if (data.id) return String(data.id);
    return hash(Object.keys(data).map(uniqueKey).join(""));
  }
  if (Array.isArray(data)) {
    return hash(data.map(uniqueKey).join(""));
  }
  console.warn("undefined key data");
  return hash(data);
}
